// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DownloadButtonController from "./download_button_controller"
application.register("download-button", DownloadButtonController)

import EmployeeAutofillController from "./employee_autofill_controller"
application.register("employee-autofill", EmployeeAutofillController)

import EmployeeLoansChartController from "./employee_loans_chart_controller"
application.register("employee-loans-chart", EmployeeLoansChartController)

import FUploadController from "./f_upload_controller"
application.register("f-upload", FUploadController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InvoiceStatisticsController from "./invoice_statistics_controller"
application.register("invoice-statistics", InvoiceStatisticsController)

import InvoiceStatusChartController from "./invoice_status_chart_controller"
application.register("invoice-status-chart", InvoiceStatusChartController)

import InvoicesController from "./invoices_controller"
application.register("invoices", InvoicesController)

import LoanStatisticsChartController from "./loan_statistics_chart_controller"
application.register("loan-statistics-chart", LoanStatisticsChartController)

import LoansController from "./loans_controller"
application.register("loans", LoansController)

import LoansSearchController from "./loans_search_controller"
application.register("loans-search", LoansSearchController)

import MainDashboardController from "./main_dashboard_controller"
application.register("main-dashboard", MainDashboardController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MonthlyInvoicesChartController from "./monthly_invoices_chart_controller"
application.register("monthly-invoices-chart", MonthlyInvoicesChartController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NoveltyToggleController from "./novelty_toggle_controller"
application.register("novelty-toggle", NoveltyToggleController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import ProductsSearchController from "./products_search_controller"
application.register("products-search", ProductsSearchController)

import RowMaterialsSearchController from "./row_materials_search_controller"
application.register("row-materials-search", RowMaterialsSearchController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SellerInvoicesChartController from "./seller_invoices_chart_controller"
application.register("seller-invoices-chart", SellerInvoicesChartController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
